export default "<div class=\"htmlBeautifyViewer\">\n    <p [innerHTML]=\"htmlContent\"></p>\n</div>\n\n"